import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { handlesGroup as e } from "../handleUtils.js";
import t from "../Logger.js";
import { isPromiseLike as s, throwIfAborted as i } from "../promiseUtils.js";
import n from "./RemoteClient.js";
var r = t.getLogger("esri.core.workers.Connection");

var l = /*#__PURE__*/function () {
  function l() {
    _classCallCheck(this, l);

    this._clients = new Array(), this._clientPromises = new Array(), this._clientIdx = 0;
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this.close();
    }
  }, {
    key: "closed",
    get: function get() {
      return !this._clients || !this._clients.length;
    }
  }, {
    key: "open",
    value: function open(e, t) {
      var _this = this;

      return new Promise(function (r, _l) {
        var o = !0;

        var h = function h(e) {
          i(t.signal), o && (o = !1, e());
        };

        _this._clients.length = e.length, _this._clientPromises.length = e.length;

        var _loop = function _loop(_i) {
          var o = e[_i];
          s(o) ? _this._clientPromises[_i] = o.then(function (e) {
            return _this._clients[_i] = new n(e, t), h(r), _this._clients[_i];
          }, function () {
            return h(_l), null;
          }) : (_this._clients[_i] = new n(o, t), _this._clientPromises[_i] = Promise.resolve(_this._clients[_i]), h(r));
        };

        for (var _i = 0; _i < e.length; ++_i) {
          _loop(_i);
        }
      });
    }
  }, {
    key: "broadcast",
    value: function broadcast(e, t, s) {
      var i = new Array(this._clientPromises.length);

      for (var _n = 0; _n < this._clientPromises.length; ++_n) {
        var _r = this._clientPromises[_n];
        i[_n] = _r.then(function (i) {
          return i.invoke(e, t, s);
        });
      }

      return i;
    }
  }, {
    key: "close",
    value: function close() {
      var _iterator = _createForOfIteratorHelper(this._clientPromises),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          _e.then(function (e) {
            return e.close();
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._clients.length = 0, this._clientPromises.length = 0;
    }
  }, {
    key: "getAvailableClient",
    value: function getAvailableClient() {
      var e;

      for (var _t = 0; _t < this._clients.length; ++_t) {
        var _s = this._clients[_t];

        if (_s) {
          if (!_s.isBusy()) return Promise.resolve(_s);
        } else e = e || [], e.push(this._clientPromises[_t]);
      }

      return e ? Promise.race(e) : (this._clientIdx = (this._clientIdx + 1) % this._clients.length, Promise.resolve(this._clients[this._clientIdx]));
    }
  }, {
    key: "invoke",
    value: function invoke(e, t, s) {
      var i = null;
      if (Array.isArray(s) ? (r.warn("invoke()", "The transferList parameter is deprecated, use the options object instead"), i = {
        transferList: s
      }) : i = s, this.closed) return Promise.reject(new Error("Connection closed"));
      return this.getAvailableClient().then(function (s) {
        return s.invoke(e, t, i);
      });
    }
  }, {
    key: "on",
    value: function on(t, s) {
      var _this2 = this;

      return Promise.all(this._clientPromises).then(function () {
        return e(_this2._clients.map(function (e) {
          return e.on(t, s);
        }));
      });
    }
  }, {
    key: "openPorts",
    value: function openPorts() {
      var _this3 = this;

      return new Promise(function (e) {
        var t = new Array(_this3._clientPromises.length);
        var s = t.length;

        var _loop2 = function _loop2(_i2) {
          _this3._clientPromises[_i2].then(function (n) {
            t[_i2] = n.openPort(), 0 == --s && e(t);
          });
        };

        for (var _i2 = 0; _i2 < _this3._clientPromises.length; ++_i2) {
          _loop2(_i2);
        }
      });
    }
  }, {
    key: "test",
    get: function get() {
      return {
        numClients: this._clients.length
      };
    }
  }]);

  return l;
}();

export { l as default };